import React from 'react';
import propTypes from 'prop-types';
import logger from 'ws-scripts/modules/logger';
import { Common } from 'ws-scripts/modules/common';

const mergeSummaryList = (itemSummaryList, sessionSummaryList) => {
	return Object.keys(itemSummaryList).reduce(
		(summary, key) => ({
			...summary,
			[key]: {
				...itemSummaryList[key],
				...sessionSummaryList[key]
			}
		}),
		{}
	);
};

// Generate Payment URL From info vehicle and payment info returned from VCDA
const CreatePaymentCalculatorURL = (paymentInfo, vehicleInfo, locale) => {
	const defaultPaymentCalcURL =
		'/calculator/payment-dealertrack-fragment.htm';

	// Null Checks
	if (
		!paymentInfo ||
		Object.keys(paymentInfo).length === 0 ||
		!Array.isArray(paymentInfo[0].payments) ||
		!paymentInfo[0].payments.length
	) {
		logger.info(
			'Create Payment Calculator URL: Fail - Missing payment info'
		);
		return defaultPaymentCalcURL;
	} else if (!vehicleInfo || !Object.keys(vehicleInfo).length) {
		logger.info(
			'Create Payment Calculator URL: Fail - Missing vehicle info'
		);
		return defaultPaymentCalcURL;
	}

	// General vehicle info
	const {
		uuid,
		type,
		year,
		make,
		model: modelType = { [locale]: '' },
		bodyStyle,
		normalBodyStyle,
		trim,
		vin,
		internetPrice,
		chromeId
	} = vehicleInfo;

	// Type Safe
	let bodyStyleType = { [locale]: '' };
	if (bodyStyle) {
		bodyStyleType = bodyStyle;
	} else if (normalBodyStyle) {
		bodyStyleType = normalBodyStyle;
	}

	let trimType = { [locale]: '' };
	if (trim) {
		trimType = trim;
	}

	// General payment info
	const { excessMileageCharge, annualMiles } = paymentInfo[0].payments[0];

	// Getting Loan and Lease Specifec info

	// Mapping lowercase finance names to having first letter uppercase
	const financeTypeNameFirstUpper = {
		loan: 'Loan',
		lease: 'Lease'
	};

	const financeTypeInfo = paymentInfo[0].payments.map(item => {
		const financeTypeName = item.financeType === 'LOAN' ? 'loan' : 'lease';
		const isLease = item.financeType === 'LEASE';
		const {
			lenderLegalName,
			downPayment,
			apr,
			term,
			payment,
			programEndDate
		} = item;

		// Funky String concats because linter won't let the line length go past a certain amount
		let toReturn = `&${financeTypeName}LenderName=${lenderLegalName}
		&${financeTypeName}DownPayment=${downPayment}
		&${financeTypeName}Apr=${apr}
		&${financeTypeName}Term${term}
		&payment${financeTypeNameFirstUpper[financeTypeName]}=${payment}
		&${financeTypeName}ProgramEndDate=${programEndDate}`;

		if (isLease) {
			toReturn += `&leaseSecurityDeposit=${item.securityDeposit}`;
		}
		return toReturn;
	});

	// Determine Finance Type
	let financeTypeName = '';
	if (paymentInfo[0].payments.length > 1) {
		financeTypeName = 'Loan_Lease';
	} else if (paymentInfo[0].payments[0].financeName === 'LEASE') {
		financeTypeName = 'Lease';
	} else if (paymentInfo[0].payments[0].financeName === 'LOAN') {
		financeTypeName = 'Loan';
	}

	// Type in payment calc URL only accepts first letter caps i.e "New" and not "NEW"
	let correctedType = type.toLowerCase();
	correctedType =
		correctedType.charAt(0).toUpperCase() + correctedType.slice(1);

	const paymentCalcURL = `${defaultPaymentCalcURL}?
	vehicleId=${uuid}
	&vehicleCondition=${correctedType}
	&year=${year}
	&make=${make}
	&model=${modelType[locale]}
	&style=${bodyStyleType[locale]}
	&trim=${trimType[locale]}
	&vin=${vin}
	&price=${internetPrice}
	&financeType=${financeTypeName}
	&instantEpriceLabel=null
	&chromeId=${chromeId}
	&excessMileageCharge=${excessMileageCharge}
	&annualMiles=${annualMiles}
	${financeTypeInfo}`;

	logger.info('Create Payment Calculator URL: Success');
	return paymentCalcURL;
};

export default class ToolboxButtons extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			updateCount: 0,
			isClient: false
		};
		this.handleButtonPress = this.handleButtonPress.bind(this);
		this.handleIsClient = this.handleIsClient.bind(this);
	}

	componentDidMount() {
		try {
			$.subscribe('dr-state-update', () => {
				this.setState({ updateCount: this.state.updateCount + 1 })
			});
			
		} catch (err) {
			logger.warn('state not subscribed to');
		}

		if(this.props.deviceType === 'MOBILE'){
			window.addEventListener('load', () => {
				this.setState({updateCount: this.state.updateCount + 1});
			})
		}

		// Catching window resizing even and using it to update clock size
		window.addEventListener('resize', () => {
			$.publish('ws-dr-resize');
		});
		this.handleIsClient();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', () => {
			$.publish('ws-dr-resize');
		});
	}

	handleIsClient() {
		this.setState({ isClient: true });
	}

	handleButtonPress() {
		this.setState({ counter: this.state.counter + 1 });
	}

	render() {
		const {
			vehicleId,
			deviceType,
			pageAlias,
			tabList,
			vehicleInfo,
			paymentInfo,
			widgetClasses,
			locale
		} = this.props;

		const paymentCalculatorURL = CreatePaymentCalculatorURL(
			paymentInfo,
			vehicleInfo,
			locale
		);

		let sessionList = null;

		if (
			typeof sessionStorage !== 'undefined' &&
			JSON.parse(sessionStorage.getItem('drSummary')) !== null
		) {
			sessionList = JSON.parse(sessionStorage.getItem('drSummary'))
				.summary;
		}

		let summaryList = sessionList
			? mergeSummaryList(tabList, sessionList)
			: tabList;

		// Also merge the summary from the DDC object into main data object. This is because it is updated first in some edge cases. 
		try{
			if( window &&
				window.DDC &&
				window.DDC.digitalRetailing &&
				window.DDC.digitalRetailing.summary && 
				summaryList){
					summaryList = mergeSummaryList(summaryList, window.DDC.digitalRetailing.summary);
				}
		} catch(err) {
			logger.warn('window.DDC.digitalRetailing.summary not found')
		}

		const mobileBtnLinks = {
			finance:
				'/financing/application.htm?category=AUTO' +
				`&vehicleId=${vehicleId}` +
				`&itemId=${vehicleId}` +
				`&referrer=${pageAlias}`,
			prequal:
				'/financing/prequalification.htm?category=AUTO' +
				`&vehicleId=${vehicleId}` +
				`&itemId=${vehicleId}` +
				`&referrer=${pageAlias}`,
			protect:
				'/digital-retailing/protect/index.htm?category=AUTO' +
				`&vehicleId=${vehicleId}` +
				`&itemId=${vehicleId}` +
				`&referrer=${pageAlias}`,
			reserve:
				'/reserve-it-now/form.htm?category=AUTO' +
				`&vehicleId=${vehicleId}` +
				`&itemId=${vehicleId}` +
				`&referrer=${pageAlias}`,
			trade:
				'/trade-driver/form.htm?category=AUTO' +
				`&vehicleId=${vehicleId}` +
				`&itemId=${vehicleId}` +
				`&referrer=${pageAlias}`
		};

		const stateLabels = {
			payment: 'WS_DR_TOOLBOX_PAYMENT_LABEL',
			prequal: 'SUBMITTED',
			protect: 'SELECTED',
			reserve: 'OSIRIS_RESERVED',
			trade: 'WS_DR_TOOLBOX_TRADE_LABEL',
			accessories: 'WS_DR_TOOLBOX_ACCESSORIES_LABEL',
			finance: 'APPROVED'
		};

		// Helper Function to create trade label
		const getTradeLabel = labels => {
			let tradeLabel;
			if( window.DDC &&
				window.DDC.userProfile.ownedVehicle &&
				window.DDC.userProfile.ownedVehicle.make &&
				window.DDC.userProfile.ownedVehicle.year &&
				window.DDC.userProfile.ownedVehicle.valuations &&
				window.DDC.userProfile.ownedVehicle.valuations.length > 0){
					const vehicleValuation = window.DDC.userProfile.ownedVehicle.valuations[window.DDC.userProfile.ownedVehicle.valuations.length - 1];
					const vehicleYear = window.DDC.userProfile.ownedVehicle.year;
					const vehicleMake = window.DDC.userProfile.ownedVehicle.make;
					const vehicleModel = vehicleValuation.thirdPartyAttributes.model;
					tradeLabel = labels.get(stateLabels.trade);
					const value = tradeLabel.substr(0, tradeLabel.indexOf(' '))
						.replace('[value]', window.DDC.format.currencyExtended(vehicleValuation.offer, {showCurrency: true}));
					const labelbody = tradeLabel.substr(tradeLabel.indexOf(' ') + 1)
						.replace('[year]', vehicleYear)
						.replace('[make]', vehicleMake)
						.replace('[model]', vehicleModel);
					tradeLabel = (
						<div>
							{value}
							<br />
							<p className='ddc-font-size-xsmall'>
								{labelbody}
							</p>
						</div>
					);
			}
			return tradeLabel
		}

		// Helper function to create payment label
		const getPaymentsLabel = labels => {
			let paymentsLabel;
			if (
				window.DDC &&
				window.DDC.userProfile.paymentQuotes &&
				window.DDC.userProfile.paymentQuotes[vehicleId]){
					const currentPayment = window.DDC.userProfile.paymentQuotes[vehicleId];
					if( currentPayment &&
						currentPayment.downPayment !== undefined &&
						currentPayment.downPayment >= 0 &&
						currentPayment.term !== undefined &&
						currentPayment.term >= 0 &&
						currentPayment.apr !== undefined &&
						currentPayment.apr >= 0){
					const term = `${currentPayment.term}`;
					const apr = `${currentPayment.apr }%`;
						paymentsLabel = labels.get(stateLabels.payment);
						const downPayment = paymentsLabel.substr(0, paymentsLabel.indexOf(' '))
							.replace('[payment]',  window.DDC.format.currencyExtended(currentPayment.downPayment, {showCurrency: true}));
						const labelbody = paymentsLabel.substr(paymentsLabel.indexOf(' ') + 1)
							.replace('[months]', term)
							.replace('[apr]', apr);
						paymentsLabel = (
							<div>
								{downPayment}
								<br />
								<p className='ddc-font-size-xsmall'>
									{labelbody}
								</p>
							</div>
						);
					}
					else{
						paymentsLabel = 'Submitted';
					}
			}
			return paymentsLabel;
		}

		// Helper function to get accessories label
		const getAccessoriesLabel = labels => {
			let accessoriesLabel;
			if (
				window.DDC &&
				window.DDC.userProfile.vehicleAccessories &&
				window.DDC.userProfile.vehicleAccessories[vehicleId] &&
				window.DDC.userProfile.vehicleAccessories[vehicleId].accessoriesTotal != null &&
				window.DDC.userProfile.vehicleAccessories[vehicleId].accessoriesTotal !== undefined ){
					const total = window.DDC.format
						.currencyExtended(window.DDC.userProfile.vehicleAccessories[vehicleId].accessoriesTotal, {showCurrency: true});
					const count = window.DDC.userProfile.vehicleAccessories[vehicleId].accessories.length;
					accessoriesLabel = labels.get(stateLabels.accessories);
					const totalLbl = accessoriesLabel.substr(0, accessoriesLabel.indexOf(' ')).replace('[total]', total);
					const labelbody = accessoriesLabel.substr(accessoriesLabel.indexOf(' ')+1).replace('[count]', count);
					accessoriesLabel = (
						<div>
							{totalLbl}
							<br />
							<p className='ddc-font-size-xsmall'>
								{labelbody}
							</p>
						</div>
					);
				}
			return accessoriesLabel;
		}

		// Returns a label to be shown when button is in COMPLETE state
		const getStateLabel = (labels, key) => {
			let stateLabel = '';
			switch (key) {
				case 'payment':
					stateLabel = getPaymentsLabel(labels);
					break;
				case 'trade':
					stateLabel = getTradeLabel(labels);
					break;
				case 'accessories':
					stateLabel = getAccessoriesLabel(labels);
					break;
				default:
					stateLabel = labels.get(stateLabels[key]);
					break;
			}
			return stateLabel;
		};

		const accessoriesURL =
			'/digital-retailing/accessories/index.htm?category=AUTO' +
			`&vehicleId=${vehicleId}` +
			`&itemId=${vehicleId}` +
			`&referrer=${pageAlias}`;

		const primaryBG = widgetClasses.includes('bg-primary');

		const openDialogTools = key =>
			deviceType === 'MOBILE' &&
			['accessories', 'payment'].includes(key) &&
			window.pubsub.publish('openDRTools', [key]);

		const DeviceTag = deviceType === 'MOBILE' ? 'a' : 'button';

		if (summaryList && this.state.isClient) {
			return (
				<Common
					render={({ flags, labels }) => {
						return (
							<div
								className={`ddc-content ${
									flags['ws-dr-toolbox-styling-fixes']
										? 'dr-buttons'
										: null
								}`}
							>
								<ul
									className={`list-unstyled nav-stacked ${
										primaryBG ? 'bg-white' : null
									}`}
								>
									{Object.keys(summaryList).map(key => {
										const item = summaryList[key];
										const BtnTag =
											deviceType === 'MOBILE' &&
											['accessories', 'payment'].includes(
												key
											)
												? 'button'
												: DeviceTag;
										return (
											<li className="clearfix" key={key}>
												<BtnTag
													onClick={() =>
														openDialogTools(key)
													}
													href={
														deviceType ===
															'MOBILE' &&
														key !== 'payment'
															? mobileBtnLinks[
																	key
															  ]
															: '#'
													}
													className={`btn btn-link text-left dr-button ${
														primaryBG
															? 'bg-white'
															: null
													} btn-block border-bottom position-relative tool pb-1 ${
														item.complete
															? 'complete'
															: 'incomplete'
													} ${
														key === 'accessories'
															? 'dialog'
															: ''
													}`}
													data-complete="ddc-icon-checkmark"
													data-incomplete="ddc-icon-checkmark"
													data-unavailable="ddc-icon-remove"
													data-digital-retail-link={
														key
													}
													data-href={
														key === 'accessories'
															? accessoriesURL
															: null
													}
													data-content-href={
														key === 'payment'
															? paymentCalculatorURL
															: null
													}
													data-digital-retail-link-type
												>
													{item.complete && (
														<div className="edit small text-uppercase float-right">
															{labels.get('EDIT')}
														</div>
													)}
													<i
														className={`dr-icon ddc-icon ddc-icon-checkmark-circle icon-size-3 float-left pr-5 ${item.complete &&
															'text-success'}`}
													/>
													<div className="tool-summary">
														<h3 className="mt-0">
															{labels.get(
																item.textAlias
															)}
														</h3>
														{item.complete && (
															<h4 className="mt-0 text-muted">
																{flags[
																	'ws-dr-toolbox-state-label-test'
																]
																	? getStateLabel(
																			labels,
																			key
																	  )
																	: labels.get(
																			'VISIT_US_TO_CONTINUE'
																	  )}
															</h4>
														)}
													</div>
												</BtnTag>
											</li>
										);
									})}
								</ul>
							</div>
						);
					}}
				/>
			);
		} else {
			return (
				<div>
					<b>Loading&nbsp;</b>
					<i className="ddc-icon ddc-icon-loading ddc-icon-size-large ddc-icon-animate-spin" />
				</div>
			);
		}
	}
}

const tabListObjectPropTypes = propTypes.shape({
	complete: propTypes.bool,
	textAlias: propTypes.string,
	time: propTypes.string
});

ToolboxButtons.propTypes = {
	deviceType: propTypes.string,
	vehicleId: propTypes.string,
	pageAlias: propTypes.string,
	tabList: propTypes.shape({
		accessories: tabListObjectPropTypes,
		finance: tabListObjectPropTypes,
		prequal: tabListObjectPropTypes,
		payment: tabListObjectPropTypes,
		protect: tabListObjectPropTypes,
		reserve: tabListObjectPropTypes,
		trade: tabListObjectPropTypes
	}),
	vehicleInfo: propTypes.shape({
		bodyStyle: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		chromeId: propTypes.string,
		internetPrice: propTypes.number,
		make: propTypes.string,
		model: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		normalBodyStyle: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		trim: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		type: propTypes.string,
		uuid: propTypes.string,
		vin: propTypes.string,
		year: propTypes.string
	}),
	paymentInfo: propTypes.arrayOf(
		propTypes.shape({
			payments: propTypes.arrayOf(
				propTypes.shape({
					annualMiles: propTypes.number,
					apr: propTypes.number,
					downPayment: propTypes.number,
					financeType: propTypes.string,
					lenderLegalName: propTypes.string,
					payment: propTypes.number,
					programEndDate: propTypes.string
				})
			)
		})
	),
	locale: propTypes.string,
	widgetClasses: propTypes.string
};

ToolboxButtons.defaultProps = {
	deviceType: 'DESKTOP',
	vehicleId: '',
	pageAlias: '',
	tabList: {},
	vehicleInfo: {},
	paymentInfo: [],
	widgetClasses: '',
	locale: 'en_US'
};



// WEBPACK FOOTER //
// ./src/components/ToolboxButtons.jsx